// apiConfig.js
const API_CONFIG = {
      apiUrl: 'https://refisc-rdc.com/',
  };
  
  export default API_CONFIG;
 